import axios from 'axios'
import store from '../store'
import router from '../router'

let baseURL = ''

if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.VUE_APP_BASE_URL
} else {
  baseURL = process.env.VUE_APP_HOST + process.env.VUE_APP_BASE_URL
}

console.log('baseUrl', baseURL)

// 创建axios实例
var Axios = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 60, // 60s超时
})

// 请求拦截
Axios.interceptors.request.use(
  // 请求发送前
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    const method = config.method ? config.method.toLowerCase() : ''
    if (method === 'get') {
      config.params = { ...config.params, seasonKey: '8th' }
    } else if (method === 'post') {
      if (config.data instanceof FormData) {
        config.data.append('seasonKey', '8th')
      } else {
        config.data = { ...config.data, seasonKey: '8th' }
      }
    }
    return config
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    return response.data.data
    // return response.data;
  },
  error => {
    if (error.response.status == 401) {
      console.log('interceptors error 401', error.response)
      // 退出登入
      localStorage.removeItem('token')
      store.commit('User/REMOVE_NICK_NAME')
      store.commit('LoginMask/SET_MASK_ACTIVE', true)
    } else {
      console.log('interceptors error other code', error.response)
      alert(error.response.data.message || error.response.statusText)
    }
    return Promise.reject(error.response)
  }
)

export default Axios
